
import * as React from 'react';
import { currentItemFacet } from '../../facets/ScopeFacets';
import { asAutoAction } from '../decorators/asAutoAction';
import { ItemOpenAction } from '../actions/open/OpenAction';
import { connectToItemCache, IItemCacheDispatchProp } from '../decorators/connectToItemCache';
import { IItemCache } from '../../models/IItemCacheObserver';
import { connectToItemsScope } from '../decorators/connectToItemsScope';

const AutoOpenAction = asAutoAction()(ItemOpenAction);

/**
 * @beta
 */
export interface IOnCurrentItemKeyChangedProps {
    previousItemKey: string | undefined;
    currentItemKey: string | undefined;
}

/**
 * @beta
 */
export interface IItemsNavigatorProps {
    itemKey?: string | undefined;
    onCurrentItemKeyChanged?: (props: IOnCurrentItemKeyChangedProps) => void;
}

interface ICurrentItemProps {
    currentItemKey: string | undefined;
}

/**
 * @beta
 */
export const ItemsNavigator: React.ComponentType<IItemsNavigatorProps> = connectToItemsScope()(connectToItemCache((
    itemCache: IItemCache,
    props: {
        itemsScopeItemKey: string;
    }
) => {
    const currentItem = itemCache.demandItemFacet(currentItemFacet, props.itemsScopeItemKey);

    return {
        currentItemKey: currentItem && currentItem.itemKey
    };
})(class extends React.Component<IItemsNavigatorProps & ICurrentItemProps> {
    public componentDidUpdate(previousProps: ICurrentItemProps & IItemsNavigatorProps & IItemCacheDispatchProp): void {
        const {
            onCurrentItemKeyChanged
        } = this.props;

        if (previousProps.currentItemKey !== this.props.currentItemKey) {
            if (onCurrentItemKeyChanged) {
                onCurrentItemKeyChanged({
                    previousItemKey: previousProps.currentItemKey,
                    currentItemKey: this.props.currentItemKey
                });
            }
        }
    }

    public componentWillMount(): void {
        const {
            onCurrentItemKeyChanged
        } = this.props;

        if (onCurrentItemKeyChanged) {
            onCurrentItemKeyChanged({
                previousItemKey: undefined,
                currentItemKey: this.props.currentItemKey
            });
        }
    }

    public render(): JSX.Element | null {
        const {
            itemKey
        } = this.props;

        return itemKey ? (
            <AutoOpenAction itemKey={ itemKey } />
        ) : null;
    }
}));
